import React, { Component } from 'react';
import versus from "../../assets/images/versus.png";
import playIcon from "../../assets/images/play-icon.png";
import leftBanner from "../../assets/images/left-banner.png";
import rightBanner from "../../assets/images/right-banner.png";
import game1 from "../../assets/images/game-1.png";
import game2 from "../../assets/images/game-2.png";
import game3 from "../../assets/images/game-3.png";
import game4 from "../../assets/images/game-4.png";

import counter1Icon from "../../assets/images/counter-icon-1.png";
import counter2Icon from "../../assets/images/counter-icon-2.png";
import counter3Icon from "../../assets/images/counter-icon-3.png";
import counter4Icon from "../../assets/images/counter-icon-4.png";
import priceCoin from "../../assets/images/price-coin.png";
import waitingIcon from "../../assets/images/waitng-icon.png";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import CallSection from '../../components/CallSection';
import TestimonialsSection from '../../components/TestimonialsSection';
import CallToAction from '../../components/CallToAction';
import FeaturesSection from '../../components/FeaturesSection';
import PlayersWeekSection from '../../components/PlayersWeekSection';
import CounterSection from '../../components/CounterSection';
import TournamentsSection from '../../components/TournamentsSection';
import HowWorksSection from '../../components/HowWorksSection';
import BannerSection from '../../components/BannerSection';
import AvailableGameSection from '../../components/AvailableGameSection';


class Home extends Component {

    render() {
        return (
            <div>
                <a href="#" class="scrollToTop"><i class="fas fa-angle-double-up"></i></a>
                <Navbar />
                <BannerSection />
                <AvailableGameSection />
                <HowWorksSection />
                <TournamentsSection />
                <CounterSection />
                <PlayersWeekSection />
                <FeaturesSection />
                <CallToAction />
                <TestimonialsSection />
                <CallSection />
                <Footer />
            </div>
        );
    }
}

export default Home;